//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'game-box',
  props: {
    game: {
      default: null,
      type: Object,
    },
    logos: {
      default: true,
      type: Boolean,
    },
    rugbyzone: {
      default: false,
      type: Boolean,
    },
    displayWinamax: {
      default: true,
      type: Boolean,
    }
  },
  data() {
    return {
      //displayWinamax: true,
      displayLogoClub: true,
      displayRugbyzone: false,
    }
  },
  mounted() {
    this.displayLogoClub = this.displayLogo;
    setTimeout(() => {
      //this.displayWinamax = this.$root.display;
      this.displayRugbyzone = this.rugbyzone;
    }, 500);

  }
}
